import {OffsetType} from '@models/pages/tableau-page/offset-type';

export class TableauPage {
  index: number = -1;
  id: string = '';
  tableauId: string = '';
  tableauProjectId: string = '';
  name: string = '';
  machineTab: boolean = false;
  visible: boolean = true;
  startTimeParameterName: string = '';
  startTimeParameterValue: number = 0;
  useStartTimeParameterValue: boolean = false;
  useStartTimeOnlyDate: boolean = false;
  endTimeParameterName: string = '';
  endTimeParameterValue: number = 0;
  useEndTimeParameterValue: boolean = false;
  useEndTimeOnlyDate: boolean = false;
  additionalParameters: string = '';
  startTimeOffsetValue: number = 0;
  startTimeOffsetType?:string =  OffsetType.HOUR;

  constructor(id: string, name: string, machineTab: boolean) {
    this.id = id;
    this.name = name;
    this.machineTab = machineTab;
  }
}